import { Box, MenuItem } from "@mui/material"
import { BoundTextField } from "lib/@components/binding/bound-components"

/**
 * Builder extra for a `currency` requested field: chooses the currency whose symbol the recipient
 * input shows. Registered as the `RequestedFieldEditor("currency")` slot plug and rendered inside the
 * row's `<Bound target={field}>`, so it binds straight to the field's `currencyCode`.
 *
 * The options mirror the symbols `currency-field-input.js` knows how to render (£/$/€); the server
 * (`share-link-fields-helpers.mjs`) defaults a missing code to "GBP".
 */
export function CurrencyCodeEditor() {
    return (
        <Box data-cy="requested-field-currency-code">
            <BoundTextField
                field="currencyCode"
                label="Currency"
                size="small"
                defaultValue="GBP"
                sx={{ minWidth: 140 }}
                select
            >
                {createCurrencyOptions()}
            </BoundTextField>
        </Box>
    )

    function createCurrencyOptions() {
        // MUI Select inspects immediate children, so these must be direct MenuItem elements.
        const options = []
        for (const option of CURRENCY_CODES) {
            options.push(createCurrencyOption(option))
        }
        return options
    }

    function createCurrencyOption(option) {
        return (
            <MenuItem key={option.value} value={option.value}>
                {option.label}
            </MenuItem>
        )
    }
}

const CURRENCY_CODES = [
    { value: "GBP", label: "GBP (£)" },
    { value: "USD", label: "USD ($)" },
    { value: "EUR", label: "EUR (€)" },
]
